import React from "react"
import { Link } from "gatsby"

import { menuData } from "../data/MenuData"

const NavOptions = () => {
  return (
    <>
      {menuData.map((item, index) => {
        return (
          <Link
            key={index}
            to={item.path}
            css={`
              font-family: "lato", sans-serif;
              display: flex;
              flex-direction: column;
              font-size: clamp(1.2rem, 1.5vw, 1.3rem);
              text-decoration: none;
              color: #000;
              padding-left: 10px;

              &:not(:first-child) {
                margin-top: clamp(1rem, 2vw, 1.2rem);
              }

              &:nth-child(3),
              &:nth-child(4),
              &:nth-child(5) {
                padding-left: 40px;
                color: #808080;
                transition: 500ms;

                &:hover {
                  color: #000;
                }
              }
            `}
          >
            {item.title}
          </Link>
        )
      })}
    </>
  )
}

export default NavOptions
